import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";

import "./context-menu.option.scss";

export const ContextMenuOption = ({ icon, label, onClick, className }) => {
  return (
    <button
      className={clsx("context-menu-option", className)}
      onClick={onClick}
    >
      <span>
        {Array.isArray(icon) ? <FontAwesomeIcon icon={icon} /> : icon}
      </span>
      <span>{label}</span>
    </button>
  );
};

ContextMenuOption.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
